import React from "react";
// import RemoveIcon from "../../../core/assets/icons/commons/remove.svg";
// import CoupangIcon from "../../../core/assets/icons/commons/coupang.svg";

interface LoadingCartProps {
  length?: number;
}

const LoadingCart: React.FC<LoadingCartProps> = ({ length = 4 }) => {
  return (
    <>
      {Array.from(Array(length).keys()).map((e: number) => (
        <div className="animate-pulse flex w-full" key={e}>
          <div className="flex-1 space-y-6 py-1">
            <div className="space-y-3">
              <div className="grid grid-cols-2 gap-4 place-items-center">
                <div className="h-4 w-full bg-gray-300 rounded col-span-1"></div>
                <div className="w-full flex justify-end">
                  <div className="flex item-center">
                    <div className="mx-2 w-[34px] h-[34px] rounded-full bg-gray-300" />
                    <div className="mx-2 w-[34px] h-[34px] rounded-full bg-gray-300" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default LoadingCart;
